import { render, staticRenderFns } from "./dataImport.vue?vue&type=template&id=2695eda4&scoped=true&"
import script from "./dataImport.vue?vue&type=script&lang=js&"
export * from "./dataImport.vue?vue&type=script&lang=js&"
import style0 from "./dataImport.vue?vue&type=style&index=0&id=2695eda4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695eda4",
  null
  
)

export default component.exports